// Plan cache — localStorage so it survives page refresh and loads instantly
// before any Firestore call, eliminating the free-plan flash for paid users.

const PLAN_KEY      = 'tf_user_plan';
const USER_DATA_KEY = 'tf_user_data';

export const getPlanFromCache = () =>
  localStorage.getItem(PLAN_KEY) || null;

export const setPlanCache = (plan) => {
  if (plan) localStorage.setItem(PLAN_KEY, plan);
};

export const clearPlanCache = () => {
  localStorage.removeItem(PLAN_KEY);
  localStorage.removeItem(USER_DATA_KEY);
  // Also clear sessionStorage flags set by App.js
  sessionStorage.removeItem('tf_isPaid');
};

export const getUserDataFromCache = () => {
  try {
    const data = localStorage.getItem(USER_DATA_KEY);
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
};

export const setUserDataCache = (data) => {
  try {
    localStorage.setItem(USER_DATA_KEY, JSON.stringify(data));
  } catch {
    // Ignore quota errors
  }
};
